export const getTermsAndPolicySelector = (state: AppState) => state.settings.termsAndPolicyData;
